/**
 * @generated SignedSource<<5ebe3e8ed9272c93d03bca92c889ab8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoRouteType = "ALIAS" | "PERMANENT_REDIRECT" | "REDIRECT";
export type CreateSeoRouteInput = {
  sourceUrl?: string | null;
  targetUrl: string;
  type: SeoRouteType;
};
export type SeoRoutesListAddMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateSeoRouteInput;
};
export type SeoRoutesListAddMutation$data = {
  readonly createSeoRoute: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoRoutesListRow_seoRoute">;
    };
  };
};
export type SeoRoutesListAddMutation = {
  response: SeoRoutesListAddMutation$data;
  variables: SeoRoutesListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SeoRoutesListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SeoRouteNode",
        "kind": "LinkedField",
        "name": "createSeoRoute",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SeoRoute",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SeoRoutesListRow_seoRoute"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SeoRoutesListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SeoRouteNode",
        "kind": "LinkedField",
        "name": "createSeoRoute",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SeoRoute",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "targetUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "packageCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monthlySourceVisits",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monthlyDestinationVisits",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SeoRouteJsonParam",
                "kind": "LinkedField",
                "name": "jsonParams",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletable",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "SeoRouteEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4bf594f933a249a023db463530c52694",
    "id": null,
    "metadata": {},
    "name": "SeoRoutesListAddMutation",
    "operationKind": "mutation",
    "text": "mutation SeoRoutesListAddMutation(\n  $input: CreateSeoRouteInput!\n) {\n  createSeoRoute(input: $input) {\n    node {\n      ...SeoRoutesListRow_seoRoute\n      id\n    }\n  }\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment SeoRouteJsonParams_seoRoute on SeoRoute {\n  jsonParams {\n    name\n    value\n  }\n}\n\nfragment SeoRoutesListRow_seoRoute on SeoRoute {\n  id\n  type\n  sourceUrl\n  targetUrl\n  packageCount\n  monthlySourceVisits\n  monthlyDestinationVisits\n  ...EntityTableRow_entity\n  ...SeoRouteJsonParams_seoRoute\n}\n"
  }
};
})();

(node as any).hash = "bb2fe2695b24e3628e9bc5a5043478c1";

export default node;
